"use client";

import Script from "next/script";

export default function GoogleAnalytics() {
  return (
    <>
      <Script
        strategy="afterInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=G-KX9YWEFRBR"
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            // Main site tracking
            gtag('config', 'G-KX9YWEFRBR');

            // Fundraising Categories tracking
            gtag('config', 'G-Q4Y8KVRVW6');

            // Fundraising Levels tracking
            gtag('config', 'G-DR2XE5JYGX');
          `,
        }}
      />
    </>
  );
}
